import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Filter } from 'src/app/user-management/_model/filter.model';
import { Sorting } from 'src/app/user-management/_model/sorting.model';
import { GlobalService } from 'src/app/_services/global.service';
import { ControlActivationService } from 'src/app/_services/control-activation.service';
import { StaffService } from '../_services/staff.service';
import { MessagesControlService } from 'src/app/_services/messages-control.service';
import { ControlDeletionService } from 'src/app/_services/control-deletion.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { Router } from '@angular/router';
import { distinctUntilChanged, Subject, Subscription, takeUntil, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UploadService } from 'src/app/user-management/_services/upload.service';
import { TranslateService } from '@ngx-translate/core';
import { AmplitudeService } from 'src/app/_services/amplitude.service';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { ModalService } from 'src/app/shared/modal/modal.service';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { ParentService } from 'src/app/user-management/_services/parent.service';
import { MatDialog } from '@angular/material/dialog';
import { PermissionDeniedDialogComponent } from 'src/app/shared/permissions/permission-denied-dialog.component';
import { Role, canManageStaffRole } from 'src/app/shared/permissions/permissions';

declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.scss']
})
export class StaffComponent implements OnInit {
  filterStatus = false;
  uploadSection = false;
  staff = [];
  user_role;
  searchText: string;
  filterValues: Filter;
  listType: string;
  compactView: boolean;
  rowsNumberToBeShowed: number;
  rowsSubscription;
  searchSubscription;
  filterSubscription;
  AllRowsIsChecked: boolean;
  selectedCheckBoxes = [];
  from: number;
  to: number;
  total: number;
  nextPage: number;
  prevPage: number;
  currentPage: number;
  lastPage: number;
  sorting: Sorting;
  loading: boolean;
  request_number: number;
  editFlags = [];
  grades: any = [];
  firstLoad = true;
  noResultsFlag:boolean=false;
  currLang;
  tableControls: any = { data: [] };
  rowsView:string='';
  destroy$ = new Subject<void>(); 
  @ViewChild('exportStaffModalContainer', { read: ViewContainerRef }) modalContainer!: ViewContainerRef;
  showSuccessPasswordResetModal: boolean = false;
  defaultPassword: string = 'Aa123456';

  constructor(
    private globalService: GlobalService,
    private uploadService: UploadService,
    private controlActivation: ControlActivationService,
    private messageControl: MessagesControlService,
    private controlDeletion: ControlDeletionService,
    private dataService: DataService,
    private translate: TranslateService,
    private router: Router,
    private staffService: StaffService,
    private amplitudesService: AmplitudeService,
    private modalService: ModalService,
    private errorMsgService: ErrorMsgService,
    private parentService: ParentService,
    private dialog: MatDialog
  ) {
      this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng =>{
        //console.log('(c)staff_(f)getLang_(L)71' , lng);
        this.currLang = lng;
        this.translate.use(this.currLang);
      });
    this.rowsSubscription = new Subscription();
    this.searchSubscription = new Subscription();
    this.filterSubscription = new Subscription();
  }

  ngOnDestroy(): void {
    this.rowsSubscription.unsubscribe();
    this.searchSubscription.unsubscribe();
    this.filterSubscription.unsubscribe();
    this.errorMsgService.setMessage(null);
    this.showSuccessPasswordResetModal = false;
  }

  ngOnInit(): void {
    // get checkbox value and assigning it to the selectedCheckBoxes property 
    this.controlDeletion.getCheckbox().pipe(takeUntil(this.destroy$)).subscribe(res=>{
      //console.log('(c)staff_(f)getCheckbox_(L)89' , res);
      this.selectedCheckBoxes = res
    })
       // to remove the black screen and the stuck error msg popup if error message was just closed in sibling component 
       $('.modal').modal('hide');
       $('body').removeClass('modal-open');
       $('.modal-backdrop').remove();  
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng =>{
      //console.log('(c)staff_(f)getLang_(L)97' , lng);
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.globalService.startLoading();
    this.dataService.getFilterStatus().pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      //console.log('(c)staff_(f)getFilterStatus_(L)97' , res);
      this.filterStatus = res;  
    })

    this.uploadService.getUploadSectionState().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)staff_(f)getUploadSectionState_(L)108' , res);
      res ? this.openUploadSection() : this.hideUploadSection();
    })
    this.dataService.setFilterValue(new Filter());
    this.request_number = 0;
    this.firstLoad = true;
    this.controlDeletion.toggleDeleteBtn(false);
    this.messageControl.toggleMessageBtn(false);
    this.currentPage = 1;
    this.sorting = {
      name: 'asc',
      grade: null,
      class: null
    }
    this.filterValues = new Filter();
    this.filterValues.grades = [];
    this.filterValues.classes = [];

    this.globalService.getLoading().pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)staff_(f)getLoading_(L)127' , res);
      this.loading = res;
    })

    this.controlActivation.getToggleUserBtn().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)staff_(f)getToggleUserBtn_(L)132' , res);
      if (Object.keys(res).length > 0) {
        res.source.checked = !res.checked;
      }
    })

    this.dataService.getRowsStyle().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)staff_(f)getRowsStyle_(L)139' , res);
      this.compactView = res;
      this.rowsView = res ? "compact" : "list";
      this.translate.get('init').pipe(takeUntil(this.destroy$)).subscribe(res => {
        //console.log('(c)staff_(f)translateInit_(L)143' , res);
        this.setTableData();
      });
      // this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(res => {
      //   this.setTableData();
      // });
      this.translate.onLangChange.pipe(
        distinctUntilChanged((prev, curr) => prev.lang === curr.lang), // Only trigger if the language changes
        tap((res) => {
          //console.log('(c)staff_(f)translateOnChange_(L)153' , res);
          this.setTableData();
        }),
        takeUntil(this.destroy$) // Automatically unsubscribe when destroy$ emits
      )
      .subscribe();
    })

    let s = this.dataService.getRowsNumberShown().subscribe(res => {
      // this.selectedCheckBoxes = [];
      this.rowsNumberToBeShowed = res;
      this.currentPage = 1;
      // this.AllRowsIsChecked = false;
      // this.dataService.setSearchText(null);
      // this.controlDeletion.toggleDeleteBtn(false);
      // this.messageControl.toggleMessageBtn(false);
      this.showList();
    })
    this.rowsSubscription.add(s);

    let x = this.dataService.getSearchText().subscribe(res => {
      if (res !== null) {
        this.firstLoad = false;
        this.selectedCheckBoxes = [];
        this.searchText = res;
        this.currentPage = 1;
        this.AllRowsIsChecked = false;
        this.controlDeletion.toggleDeleteBtn(false);
        this.messageControl.toggleMessageBtn(false);
        this.showList();
      }
    })
    this.searchSubscription.add(x);

    let f = this.dataService.getFilterValue().subscribe((res: any) => {
      this.firstLoad = false;
      this.currentPage = 1;
      this.filterValues = res;
      this.AllRowsIsChecked = false;
      this.selectedCheckBoxes = [];
      this.controlDeletion.toggleDeleteBtn(false);
      this.messageControl.toggleMessageBtn(false);
      if (Object.keys(this.filterValues).length !== 0) {
        this.showList();
      }
    })
    this.filterSubscription.add(f);

    this.dataService.getGrades().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)staff_(f)getGrades_(L)193' , res);
      this.grades = res;
    });
  }

  showList() {
    this.globalService.startLoading();
    this.request_number = this.request_number + 1;
    this.listType = window.location.pathname.split('/')[2];
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      //console.log('(c)staff_(f)router events_(L)203' , res);
      if (res.url) {
        this.listType = res.url.split('/')[2];
      }
    })
    switch (this.listType) {
      case 'staff':
        this.staffService.getStaff(this.rowsNumberToBeShowed, this.currentPage, this.sorting, this.searchText, this.filterValues, this.request_number).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
          //console.log('(c)staff_(f)getStaff_(L)211' , res);   
          if (this.request_number == res.request_number) {
            this.staff = res.data;
            this.staff.forEach(staff => {
              staff.role=staff.roles[0]?.name;
            });
            this.editFlags = (new Array(res.data.length)).fill(false);
            this.from = res.from;
            this.to = res.to;
            this.total = res.total;
            this.lastPage = res.last_page;
            this.translate.get('init').pipe(takeUntil(this.destroy$)).subscribe(res => {
              //console.log('(c)staff_(f)translateInit_(L)223' , res);   
              this.setTableData();
            });
            // this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(res => {
            //   this.setTableData();
            // });
            this.translate.onLangChange.pipe(
              distinctUntilChanged((prev, curr) => prev.lang === curr.lang), // Only trigger if the language changes
              tap((res) => {
                //console.log('(c)staff_(f)translateOnChange_(L)233' , res);   
                this.setTableData();
              }),
              takeUntil(this.destroy$) // Automatically unsubscribe when destroy$ emits
            )
            .subscribe();
            if (this.selectedCheckBoxes.length === 0) {
              this.staff.map(oneStaff => {
                oneStaff['isSelected'] = false;
              })
            }
            else {
              this.selectedCheckBoxes.map(selectedCB => {
                let staffIndex = this.staff.findIndex(oneStaff => selectedCB.id === oneStaff.id);
                if (staffIndex !== -1) {
                  this.staff[staffIndex].isSelected = true;
                }
              })
              if (this.staff.length > 0 && this.staff.every(oneStaff => oneStaff.isSelected === true)) {
                this.AllRowsIsChecked = true;
              }
              else {
                this.AllRowsIsChecked = false;
              }
            }
            this.globalService.stopLoading();
          }
        })
        break;
    }
  }

  getImage(imagePath: string) {
    return environment.img_url + imagePath;
  }

  changeActivation(event, parent) {
    let body = { 'noOfShownRows': this.rowsNumberToBeShowed, 'type': this.listType, 'userName': parent.name, 'userId': parent.id, 'state': event.checked, 'event': event }
    this.controlActivation.setToggledUSer(body);
    $("#confirmModal").modal("show");
  }


  previousBtnHandler() {
    if (this.currentPage > 1) {
      this.currentPage = this.currentPage - 1;
      this.showList()
    }
  }

  nextBtnHandler() {
    if (this.currentPage < this.lastPage) {
      this.currentPage = this.currentPage + 1;
      this.showList();
    }
  }

  paginationHandling(event){
    this.currentPage += event.dir;
    this.showList();
  }
  toggleSorting(sortingBy: string) {
    let previousValuesOfSorting = this.sorting;
    this.sorting = {
      name: null,
      grade: null,
      class: null
    }
    this.sorting[sortingBy] = previousValuesOfSorting[sortingBy] === 'asc' ? 'desc' : 'asc';
    this.showList();
  }

  viewStaff(staff) {
    this.staffService.getStaffById(staff.id).pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)staff_(f)viewStaff_(L)298' , res);   
      this.staffService.setStaffData(res, 'view');
      $('#addStaffModal').modal("show");
    })
  }

  // Managers can't act on School Admin accounts; show the denied dialog and report whether to stop.
  private blockedByRole(staff): boolean {
    const loginAs = (localStorage.getItem('loginAs') || '').trim() as Role;
    if (canManageStaffRole(loginAs, staff?.role)) { return false; }
    this.dialog.open(PermissionDeniedDialogComponent, { width: '400px' });
    return true;
  }

  editStaff(e,staff, focus?: 'links') {
    e.stopPropagation();
    if (this.blockedByRole(staff)) { return; }
    this.staffService.getStaffById(staff.id).pipe(takeUntil(this.destroy$)).subscribe(res => {
      //console.log('(c)staff_(f)editStaff_(L)307' , res);   
      this.staffService.setStaffData(res, 'edit', focus);
      $('#addStaffModal').modal("show");
    })
  }

  addStaff() {
    this.amplitudesService.trackEvent('CTA.Add_Staff',{});
    this.staffService.setStaffData({}, 'add');
    $("#addStaffModal").modal("show");
  }

  openUploadSection() {
    this.uploadSection = true;
    this.amplitudesService.trackEvent('CTA.Upload_Staff',{})
  }

  hideUploadSection() {
    this.uploadSection = false;
  }

  setTableData() {
    this.tableControls = {
      selection: true,
      paging: true,
      view: this.rowsView,
      title:'table-view.titles.staff',
      selectedTitle:'table-view.selected-titles.staff',
      totalTitle:'table-view.total-titles.staff',
      pagination: {
        from: this.from,
        to: this.to,
        total: this.total
      },
      columns: [
        {
          name: "",
          sort: false,
          type: "image",
          source: "image_path"
        },
        {
          name: this.translate.instant('staff-table.name'),
          sort: true,
          type: "string",
          source: "name"
        },
        {
          name: this.translate.instant('staff-table.phone-number'),
          sort: false,
          type: "string",
          source: "phone_number"
        },
        {
          name: this.translate.instant('staff-table.email'),
          sort: false,
          type: "string",
          source: "email"
        },
        {
          name: this.translate.instant('staff-table.role'),
          sort: false,
          type: "string",
          source: "role",
          translateRole: true
        },
        {
          name: this.translate.instant('staff-table.assigned-to'),
          sort: false,
          type: "assigned-to-by-role",
        },
        {
          name: this.translate.instant('staff-table.quick-actions'),
          sort: false,
          type: "quick-actions",
        },
        // {
        //   name: this.translate.instant('staff-table.assign-to'),
        //   sort: false,
        //   type: "multipleValues",
        // },
      ],
      data:this.staff
    }
  }

  tableEventHandeler(event) {
    console.log('(c)staff_(f)tableEventHandeler_(L)413' , event);
    switch (event.action) {
      case "rowClicked":
        this.viewStaff(event.target.data);
        break;
        case "edit":
          this.editStaff(event.e,event.target.data);
        break;
        case "reset-password":
          this.resetPassword(event.target.data);
        break;
        case "copy-email":
          this.copyEmail(event.e,event.target.data);
        break;
        case "assign-class":
          this.editStaff(event.e,event.target.data, 'links');
        break; 
        case "delete":
          this.deleteStaff(event.target.data);
        break;
      case "checkboxChanged":
        this.selectChanged(event.target);
        break;
        case "activationChanged":
          this.changeActivation(event.e,event.target.data);
          break;
      case "sorting":
        this.toggleSorting(event.target.source);
        break;
      case "pagination":
        this.paginationHandling(event.target);
        break;
        case "scroll":
        break;
    }
  }

  selectChanged(event) {
    let index = event.index;
    let row = event.data;
    let allRows=event.dataValues;
    let checked = event.checked;
    if (checked) { // checked
      if (index == "all") {
            this.selectedCheckBoxes = allRows;
          } else {
        this.selectedCheckBoxes.push(row);
    }
    } else { // unchecked
      if (index == "all") {
            this.selectedCheckBoxes = [];
          } 
          else {
            this.selectedCheckBoxes = this.selectedCheckBoxes.filter(selected=> selected.id != row.id);
          }
    }

    if (this.selectedCheckBoxes.length > 0) {
      this.controlDeletion.toggleDeleteBtn(true);
      this.messageControl.toggleMessageBtn(true);
    } else {
      this.controlDeletion.toggleDeleteBtn(false);
      this.messageControl.toggleMessageBtn(false);
    }
  }

  generateExcelFile() {
    this.openExportModal('export-staff' , 'view' , null)
  }

  openExportModal(modalType:string , mode:string , data:any): void {
    const modalConfig = this.modalService.createModalConfig(modalType , mode , data  );
    this.modalService.openModal(modalConfig, this.modalContainer);
  }

  copyEmail(e,staff) {
    navigator.clipboard.writeText(staff.email);
  }

  resetPassword(staff) {
    if (this.blockedByRole(staff)) { return; }
    this.loading = true;
    let body = {
      national_id: staff?.national_id
    }
    this.staffService.resetStaffPassword(body).subscribe(res => {
      console.log(res);
      this.showSuccessPasswordResetModal = true;
      this.loading = false;
    }, error => {
      this.errorMsgService.setMessage(error.error.message);
      this.showSuccessPasswordResetModal = false;
      this.loading = false;
    })
  }

  closeModal() {
    this.showSuccessPasswordResetModal = false;
  }

  deleteStaff(staff) {
    if (this.blockedByRole(staff)) { return; }
    this.loading = true;
    let body = { 'role':'staff', 'user_ids': [staff?.id] }
    // delete parents is same as delete users 
    this.parentService.deleteParents(body).subscribe(res => {
      //  set the checkbox value as an observable of empty array after deletion is done
      this.loading = false;
      this.dataService.setRowsNumberShown(this.rowsNumberToBeShowed);

    },err=>{
      this.loading = false;
      this.errorMsgService.setMessage(err.error.message)
    })
  }
}
